import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './CalendarHeader.module.css';

const MONTHS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
];

const SHORT_MONTHS = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
];

function getWeekTitle(date) {
  const start = new Date(date);
  start.setDate(start.getDate() - start.getDay());
  const end = new Date(start);
  end.setDate(end.getDate() + 6);

  if (start.getMonth() === end.getMonth()) {
    return `${MONTHS[start.getMonth()]} ${start.getDate()}\u2013${end.getDate()}, ${start.getFullYear()}`;
  }
  if (start.getFullYear() === end.getFullYear()) {
    return `${SHORT_MONTHS[start.getMonth()]} ${start.getDate()} \u2013 ${SHORT_MONTHS[end.getMonth()]} ${end.getDate()}, ${start.getFullYear()}`;
  }
  return `${SHORT_MONTHS[start.getMonth()]} ${start.getDate()}, ${start.getFullYear()} \u2013 ${SHORT_MONTHS[end.getMonth()]} ${end.getDate()}, ${end.getFullYear()}`;
}

function CalendarHeader({ currentDate, viewMode, onViewChange, onNavigate, onToday, draftsCount, onDraftsClick, showWeekends, onWeekendsToggle }) {
  const navigate = useNavigate();
  const title = viewMode === 'week'
    ? getWeekTitle(currentDate)
    : `${MONTHS[currentDate.getMonth()]} ${currentDate.getFullYear()}`;

  return (
    <div className={styles.header}>
      <div className={styles.left}>
        <h1 className={styles.title}>
          {title}
        </h1>
        <div className={styles.navButtons}>
          <button className={styles.navBtn} onClick={() => onNavigate(-1)} aria-label="Previous">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="15 18 9 12 15 6" />
            </svg>
          </button>
          <button className={styles.todayBtn} onClick={onToday}>
            Today
          </button>
          <button className={styles.navBtn} onClick={() => onNavigate(1)} aria-label="Next">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="9 18 15 12 9 6" />
            </svg>
          </button>
        </div>
      </div>
      <div className={styles.right}>
        <button className={styles.newClassBtn} onClick={() => navigate('/onboarding')}>
          + Plan a New Class
        </button>
        <button className={styles.coverageBtn} onClick={() => navigate('/coverage')}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
            <polyline points="22 4 12 14.01 9 11.01" />
          </svg>
          Standards
        </button>
        {draftsCount > 0 && (
          <button className={styles.draftsBadge} onClick={onDraftsClick}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
              <polyline points="14 2 14 8 20 8" />
            </svg>
            {draftsCount} draft{draftsCount !== 1 ? 's' : ''}
          </button>
        )}
        <button
          className={`${styles.weekendToggle} ${showWeekends ? styles.weekendToggleActive : ''}`}
          onClick={onWeekendsToggle}
        >
          {showWeekends ? '7 days' : '5 days'}
        </button>
        <div className={styles.viewToggle}>
          <button
            className={`${styles.viewBtn} ${viewMode === 'month' ? styles.viewBtnActive : ''}`}
            onClick={() => onViewChange('month')}
          >
            Month
          </button>
          <button
            className={`${styles.viewBtn} ${viewMode === 'week' ? styles.viewBtnActive : ''}`}
            onClick={() => onViewChange('week')}
          >
            Week
          </button>
        </div>
      </div>
    </div>
  );
}

export default CalendarHeader;
